import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-info-header',
  templateUrl: './info-header.component.html',
  styleUrls: ['./info-header.component.css']
})
export class InfoHeaderComponent implements OnInit {

  @Input() header: any;
  constructor() { }

  ngOnInit() {
  }

}
